import { Box, Typography, Grid, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";

const AboutContainer = () => {
  const openingParagraph = `The Delina Research Group is led by Dr. Laurence L. Delina, assistant professor of environment and sustainability. 
  His research interests are on sustainable development with focus on rapid mitigation of climate change and accelerating sustainable and just energy transitions. 
  His research received funding from the Hong Kong Research Grants Council, the United States Institute of Peace, the Sumitomo Foundation, and the Robert H.N. Ho Family 
  Foundation. Laurence is an associate editor of Energy Research & Social Science, an affiliate of HKUST’s Institute for Emerging Market Studies, Energy Institute, and the 
  Fok Ying Tung Research Institute. He has written for the Philippine Daily Inquirer, Bangkok Post, Jakarta Post and The Conversation, and appeared in Al Jazeera, 
  Fortune, and ABS-CBN News. Laurence was a Rachel Carson Fellow, a Balik Scientist, and a Visiting Fellow at Harvard Kennedy School. He received his PhD from the 
  University of New South Wales Sydney.  `;
  const navigate = useNavigate();

  return (
    <>
      <>
        <Box
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "2em",
          }}
        >
          <Box
            style={{
              width: "100%",
              background:
                "linear-gradient(180deg, #004C98 0%, rgba(90, 139, 188, 0.646736) 38.69%, rgba(255, 255, 255, 0) 100%)",
            }}
          >
            <Typography
              style={{
                padding: "32px",
                width: "100%",
                justifyContent: "flex-end",
                display: "flex",
                boxSizing: "border-box",
                marginRight: "32px",
              }}
              fontSize="32px"
              fontWeight={600}
            >
              ABOUT
            </Typography>
          </Box>
          <Box
            style={{
              maxWidth: "960px",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container>
              <Grid item xs={3}>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    background: "#003366",
                    padding: "12px",
                    boxSizing: "border-box",
                  }}
                >
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/Images/ProfilePic/DELINA-Laurence.jpg"
                    }
                    alt="Profile Pic"
                    width="-webkit-fill-available"
                    style={{
                      boxSizing: "border-box",
                      padding: "24px",
                    }}
                  />
                  <Typography
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontWeight: 600,
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                    noWrap
                  >
                    LAURENCE L. DELINA, Ph.D.
                  </Typography>
                  <Typography
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontWeight: 600,
                      fontSize: "14px",
                    }}
                  >
                    Assistant Professor
                  </Typography>
                  <Typography
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    Division of Environment and Sustainability
                  </Typography>
                  <Typography
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "12px",
                    }}
                  >
                    HKUST
                  </Typography>
                  <Typography
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "12px",
                    }}
                  >
                    lld@ust.hk
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    marginTop: "12px",
                  }}
                >
                  {/* <Link
                    href="https://www.instagram.com/laurencedelina/"
                    style={{ marginLeft: "4px" }}
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "Images/SocialMedia/instagram2.jpg"
                      }
                      alt="facebook"
                      width="80%"
                    />
                  </Link>
                  <Link
                    href="https://www.facebook.com/lld12345"
                    style={{ marginLeft: "4px" }}
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "Images/SocialMedia/facebook2.jpg"
                      }
                      alt="facebook"
                      width="80%"
                    />
                  </Link> */}
                  <Link
                    href="https://twitter.com/laurencedelina"
                    style={{ marginLeft: "4px" }}
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "Images/SocialMedia/twitter2.jpg"
                      }
                      alt="facebook"
                      width="80%"
                    />
                  </Link>
                  <Link
                    href="https://www.amazon.com/Laurence-L-Delina/e/B01A64705W%3Fref=dbs_a_mng_rwt_scns_share"
                    style={{ marginLeft: "4px" }}
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL + "Images/SocialMedia/amazon.jpg"
                      }
                      alt="facebook"
                      width="80%"
                    />
                  </Link>
                  <Link
                    href="https://orcid.org/0000-0001-8637-4609"
                    style={{ marginLeft: "4px" }}
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL + "Images/SocialMedia/orcid.jpg"
                      }
                      alt="facebook"
                      width="80%"
                    />
                  </Link>
                </Box>
              </Grid>
              <Grid item xs={9}>
                <Box
                  style={{
                    paddingLeft: "24px",
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "8px",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <Box>
                    <Typography
                      fontWeight={600}
                      fontSize="28px"
                      style={{ marginBottom: "12px" }}
                    >
                      The Delina Research Group
                    </Typography>
                    <Typography>{openingParagraph}</Typography>
                  </Box>
                  {/* <Typography fontWeight={600} fontSize="18px">
                    lld@ust.hk
                  </Typography> */}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box
          style={{
            background: "#003366",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "240px",
          }}
        >
          <Box
            style={{
              maxWidth: "960px",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  color="white"
                  fontWeight={600}
                  fontSize="28px"
                  style={{ padding: "16px" }}
                >
                  More About Dr. Delina
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} style={{ boxSizing: "border-box" }}>
              <Grid item xs={3} style={{ position: "relative" }}>
                <Box
                  style={{
                    backgroundImage: `url(${
                      process.env.PUBLIC_URL + "/Images/aboutMember.jpg"
                    })`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    padding: "64px 24px",
                    borderRadius: "16px",
                    filter: "blur(4px)",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/about/members")}
                />
                <Box
                  style={{
                    position: "relative",
                    bottom: "50%",
                    background: "rgba(0, 0, 0, 0.4)",
                    padding: "16px 8px",
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "16px",
                    justifyContent: "center",
                    margin: "0px 16px",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/about/members")}
                >
                  <Typography
                    style={{ textAlign: "center" }}
                    color="white"
                    fontWeight={600}
                  >
                    Research Group Members
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box
                  style={{
                    backgroundImage: `url(${
                      process.env.PUBLIC_URL + "/Images/aboutMember.jpg"
                    })`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    padding: "64px 24px",
                    borderRadius: "16px",
                    filter: "blur(4px)",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/about/awards")}
                />
                <Box
                  style={{
                    position: "relative",
                    bottom: "50%",
                    background: "rgba(0, 0, 0, 0.4)",
                    padding: "16px 8px",
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "16px",
                    justifyContent: "center",
                    margin: "0px 16px",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/about/awards")}
                >
                  <Box style={{ display: "flex", flexDirection: "column" }}>
                    <Typography
                      style={{ textAlign: "center" }}
                      color="white"
                      fontWeight={600}
                    >
                      Awards and
                    </Typography>
                    <Typography
                      style={{ textAlign: "center" }}
                      color="white"
                      fontWeight={600}
                    >
                      Fellowships
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box
                  style={{
                    backgroundImage: `url(${
                      process.env.PUBLIC_URL + "/Images/aboutMember.jpg"
                    })`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    padding: "64px 24px",
                    borderRadius: "16px",
                    filter: "blur(4px)",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/about/talks")}
                />
                <Box
                  style={{
                    position: "relative",
                    bottom: "45%",
                    background: "rgba(0, 0, 0, 0.4)",
                    padding: "16px 8px",
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "16px",
                    justifyContent: "center",
                    margin: "0px 16px",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/about/talks")}
                >
                  <Typography
                    style={{ textAlign: "center" }}
                    color="white"
                    fontWeight={600}
                  >
                    Invited Talks
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box
                  style={{
                    backgroundImage: `url(${
                      process.env.PUBLIC_URL + "/Images/aboutMember.jpg"
                    })`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    padding: "64px 24px",
                    borderRadius: "16px",
                    filter: "blur(4px)",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/about/teaching")}
                />
                <Box
                  style={{
                    position: "relative",
                    bottom: "45%",
                    background: "rgba(0, 0, 0, 0.4)",
                    padding: "16px 8px",
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "16px",
                    justifyContent: "center",
                    margin: "0px 16px",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/about/teaching")}
                >
                  <Typography
                    style={{ textAlign: "center" }}
                    color="white"
                    fontWeight={600}
                  >
                    Teaching
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "2em",
            paddingTop: "2em",
          }}
        >
          <Box
            style={{
              maxWidth: "960px",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
              <Typography
                fontWeight={600}
              >{`Go back to Homepage >>>`}</Typography>
            </Box>
          </Box>
        </Box>
      </>
    </>
  );
};

export default AboutContainer;
